import { combineReducers } from '@reduxjs/toolkit'
import { LabDataReducer } from './reducers/Lab-Reducers'
import { PaymentDataReducer } from './reducers/Payment-Reducers'

const RootReducer = combineReducers({
  labData: LabDataReducer,
  paymentData: PaymentDataReducer,
})

export default RootReducer
